import { colors, s16, s24, s32, s64 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { Header5 } from '@ardoq/typography';

const Wrapper = styled.div`
  border-left: 1px solid ${colors.borderAction};
  color: ${colors.textSubtle};
  position: relative;
  margin: -999999px ${s64}; /* This is a hack to show the divider border when we have a notification in the layout. The container should have 'overflow: hidden' to hide the border that falls outside the container. */
`;

const Divider = styled.div`
  position: absolute;
  top: 50%;
  margin-top: -${s24};
  background: ${colors.surfaceDefault};
  padding: ${s16};
  width: ${s64};
  margin-left: -${s32};
  text-align: center;
`;

export const DividerBlock = () => (
  <Wrapper>
    <Divider>
      <Header5>OR</Header5>
    </Divider>
  </Wrapper>
);
